module.exports = __webpack_public_path__ + "img/p43.f23cad80.jpg";